import * as yup from "yup";

const requiredValueObject = (fieldName) =>
    yup.mixed().test(fieldName, `${fieldName} is required`, (val) => {
        if (!val) return false;
        if (typeof val === "string") return val.trim().length > 0;
        if (typeof val === "object" && val.value) {
            return String(val.value).trim().length > 0;
            }

        return false;
});

export const specializationSchema = yup.object().shape({
  specialisationId: yup.string().nullable(),
  universityId: requiredValueObject("University"),
  courseId: requiredValueObject("Course"),
  specializationNameId: requiredValueObject("Specialization"),
  description: yup.string().required("Description is required"),
  whyChooseThisSpecialisation: yup
    .array()
    .of(yup.string().required("Required")),
    // .min(1, "At least one reason is required"),

  keySkillsTaught: yup
    .array()
    .of(yup.string().required("Required")),
    // .min(1, "At least one key skill is required"),

  semesterWiseCurriculum: yup
    .array()
    .of(
      yup.object().shape({
        year: yup.number().required("Year is required"),
        sem: yup.number().required("Semester is required"),
        value: yup.string().required("Curriculum description is required"),
      })
    )
    .min(1, "At least one semester entry is required"),

  careerOpportunities: yup.string().required("Career opportunities are required"),

  topRecruitersId: yup
    .array()
    .of(
      yup.object().shape({
        // label: yup.string().required("Recruiter name is required"),
        value: yup.string().required("Recruiter ID is required"),
        image: yup.string().url("Invalid recruiter image URL").nullable(),
      })
    )
    .min(1, "At least one recruiter is required"),

  averagePackageOffered: yup.object().shape({
    amountFrom: yup.string("Must be number").required("Starting package is required"),
    // currencyFrom: yup.string().required("Currency is required"),
    amountTo: yup.string("Must be number").required("Maximum package is required"),
    // currencyTo: yup.string().required("Currency is required"),
  }),

  whoShouldPursueThis: yup.string().required("Who should pursue is required"),

  toolsTechnologiesUsedId: yup
    .array()
    .of(
      yup.object().shape({
        // label: yup.string().required("Tool/technology name is required"),
        value: yup.string().required("Tool/technology ID is required"),
        image: yup.string().url("Invalid tool image URL").nullable(),
      })
    )
    .min(1, "At least one tool/technology is required"),

  internshipMandatory: yup.string().oneOf(["yes", "no"],"Please select yes/no for internship").required("Internship requirement is required"),
  projectsIncluded: yup.string().oneOf(["yes", "no"],"Please select yes/no for project").required("Projects requirement is required"),
  minimumQualification: yup.string(),
//   .required("Minimum qualification is required"),

  minimumPercentageCGPA: yup.object().shape({
    type: yup.string(),
    // .required("Selection is required"),
    value: yup.string(),
    // .required("Selection is required"),
  }),

  entranceExamRequired: yup.array().of(yup.string()),
//   .min(1, "At least one exam detail is required"),

  workExperienceRequired: yup.object().shape({
    isRequired: yup.boolean(),
    experience: yup.string().when("isRequired", {
      is: true,
      then: (schema) => schema.required("Experience details are required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  }),

  streamBackground: yup.string(),
//   .required("Stream background is required"),
  otherRequirements: yup.string(),
//   .required("Other requirement is required"),

  applicationPeriod: yup.object().shape({
    start: yup.date(),
    // .required("Application start date is required"),
    end: yup
      .date(),
    //   .required("Application end date is required")
    //   .min(yup.ref("start"), "End date must be after start date"),
  }),

  admissionSteps: yup.array().of(yup.string().required("Step is required")),
//   .min(1, "At least one admission step is required"),
  documentsRequired: yup.array().of(yup.string().required("Document is required")),
//   .min(1, "At least one document is required"),
  selectionCriteria: yup.string(),
//   .required("Selection criteria is required"),
  interviewRequired: yup.string().oneOf(["yes", "no"],"Please select yes/no for interview").required("Interview is required"),

  feeAndCertForm: yup.object().shape({
    fees: yup.object().shape({
      totalAmount: yup.string().matches(/^\d+(\.\d+)?$/, "Total fee amount must be a valid number").required("Total fee amount is required"),
      fees: yup
        .array()
        .of(
          yup.object().shape({
            amount: yup.string().matches(/^\d+(\.\d+)?$/, "Fee amount must be a valid number").required("Fee amount is required"),
            currency: yup.string().required("Fee currency is required"),
          })
        ),
        // .min(1, "At least one fee breakdown entry is required"),
    }),
    //   certification: yup
    //       .object({
    //           fileUrl: yup
    //               .string()
    //               .url("Invalid certification file URL")
    //               .required("Certification file is required"),
    //           fileName: yup
    //               .string().nullable()
    //               .required("Certification file name is required"),
    //       })
    //       .required("Certification is required")
    //       .typeError("Certification is required"),

    feeBreakdown: yup.array().of(yup.object()).nullable(),
  }),
});
